import { CoreGameGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/CoreGameGameCommunicationProcessor';
import type { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';
import { gameStateActions } from '@pp/core/src/store/slices/game/slice';
interface GameMessage extends GameCommunicationMessageType {
  id?: string;
}

export class GameCommunicationCrashGameProcessor
  extends CoreGameGameCommunicationProcessor
{
  delay = 0;
  process(message: GameMessage): void {
    const { gameId } = this.store.getState().gameState;
    const newGameId = message.id as string;

    if (gameId !== newGameId) {
      this.store.dispatch(gameStateActions.setGameId(newGameId));
      setTimeout(() => {
        this.store.dispatch(gameStateActions.resetForNewGame());
      }, 3000);
    }
  }
}
